import { create } from 'zustand';

/** The pass a product card just bought, per storefront. */
type Fresh = null | { tutorUsername: string; courseId: string };

interface FreshPassState {
  fresh: Fresh;
  /** The webhook answered: the grid card that took the money stands as this pass. */
  landed: (tutorUsername: string, courseId: string) => void;
}

// In memory on purpose: the card turns into the pass for this visit, and a
// reload lays the pass where every pass goes, in the intro card.
export const useFreshPass = create<FreshPassState>((set) => ({
  fresh: null,
  landed: (tutorUsername, courseId) => set({ fresh: { tutorUsername, courseId } }),
}));
